const rules = {
	user: {
		static: [
			"drawer-kanban:view",
		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"drawer-kanban:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"kanban-settings:manage",
		],
	},
};

export default rules;
